import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiPhone, FiMapPin, FiShield, FiFacebook, FiLinkedin } = FiIcons;

const Footer = () => {
  return (
    <footer className="bg-black py-12">
      <div className="max-w-6xl mx-auto px-4">
        <div className="grid md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-2xl font-bold text-white mb-4">
              Business Internet <span className="text-red-400">Savings</span>
            </h3>
            <p className="text-gray-400 mb-4">
              Professional internet bill negotiation services for businesses in NYC and Hudson Valley.
            </p>
            <div className="flex items-center gap-2 text-green-400 mb-4">
              <SafeIcon icon={FiShield} />
              <span className="text-sm">100% Secure & Confidential</span>
            </div>
            {/* Social Media Links */}
            <div className="space-y-3">
              <div className="flex items-center gap-2">
                <a 
                  href="https://www.facebook.com/ClarkRitchotte" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="bg-blue-600 hover:bg-blue-700 p-2 rounded-full transition-colors duration-300"
                >
                  <SafeIcon icon={FiFacebook} className="text-white text-xl" />
                </a>
                <span className="text-gray-400 text-sm">Follow us on Facebook</span>
              </div>
              <div className="flex items-center gap-2">
                <a 
                  href="https://www.linkedin.com/company/clarkritchotte/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="bg-blue-700 hover:bg-blue-800 p-2 rounded-full transition-colors duration-300"
                >
                  <SafeIcon icon={FiLinkedin} className="text-white text-xl" />
                </a>
                <span className="text-gray-400 text-sm">Connect on LinkedIn</span>
              </div>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold text-white mb-4">Contact Info</h4>
            <div className="space-y-3">
              <div className="flex items-center gap-2 text-gray-400">
                <SafeIcon icon={FiPhone} />
                <span>+1 855-758-5229</span>
              </div>
              <div className="flex items-center gap-2 text-gray-400">
                <SafeIcon icon={FiMapPin} />
                <span>200 Broadway, Floor 3, New York, New York, 10038</span>
              </div>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold text-white mb-4">Service Areas</h4>
            <div className="grid grid-cols-2 gap-2 text-gray-400 text-sm">
              <div>Manhattan</div>
              <div>Brooklyn</div>
              <div>Queens</div>
              <div>Bronx</div>
              <div>Staten Island</div>
              <div>Westchester</div>
              <div>Rockland</div>
              <div>Orange County</div>
              <div>Dutchess</div>
              <div>Ulster</div>
            </div>
          </div>
        </div>

        {/* Transparency Disclaimer in Footer */}
        <div className="border-t border-gray-800 mt-8 pt-6">
          <div className="bg-gray-900 border border-gray-700 rounded-lg p-4 mb-4">
            <p className="text-gray-400 text-xs leading-relaxed text-center">
              <strong className="text-yellow-400">Disclaimer:</strong> Not all customers will qualify for price reductions. Eligibility may be affected by existing contracts, current promotional pricing, Dedicated Internet Access (DIA) plans, or if you're already receiving the best available rate from your provider.
            </p>
          </div>
          <p className="text-gray-400 text-sm text-center">
            © 2024 Clark-Ritchotte Communications and Affiliated Companies. All rights reserved.
            <span className="text-red-400 mx-2">|</span>
            Business internet cost reduction services serving NYC and Hudson Valley.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;